// removed by extract-text-webpack-plugin
module.exports = {"leftCell":"leftCell__2Vn2HodZ1cDX"};